import React from 'react'
import PropTypes from 'prop-types'

import Align from './Align.jsx'
import Margin from './Margin.jsx'

const LoadingState = ({ marginTop }) => {
  return (
    <Margin top={marginTop}>
      <Align childrenRect={{ x: 0, y: 0, width: 60, height: 60 }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="60"
          height="60"
          viewBox="0 0 60 60"
          fill="none"
        >
          <g className="ai-svg-spinner">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M30 58C45.464 58 58 45.464 58 30C58 14.536 45.464 2 30 2C14.536 2 2 14.536 2 30C2 45.464 14.536 58 30 58Z"
              stroke="#ECF3EE"
              strokeWidth="4"
            />
            <path d="M30 2C14.536 2 2 14.536 2 30" stroke="#13682B" strokeWidth="4" />
          </g>
        </svg>
      </Align>
    </Margin>
  )
}

LoadingState.propTypes = {
  marginTop: PropTypes.number,
}

LoadingState.defaultProps = {
  marginTop: 0,
}

export default LoadingState
